import React from "react";
import { Fragment, useState, useEffect } from "react";
import { useQuery } from "@apollo/client";
import {
  useMyOrgInfo,
  useLoginStatus,
  useUserInfo,
} from "../../../../Layout/AppMain/LoginStatusContext";
import CSSTransitionGroup from "react-transition-group/CSSTransitionGroup";
import _ from "lodash";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Button,
  Collapse,
  Modal,
  ModalBody,
} from "reactstrap";
import { Link } from "react-router-dom";
import * as Ionicons from "react-icons/io";
import { useMutation } from "@apollo/client";
import { CREATE_PROJECT, GET_PROJECTS } from "../../../../queries";
import { DropdownList } from "react-widgets";
import animetionLogo from "../../../../assets/utils/images/animetion_logo.gif";

// EMA Component
import CustomTable from "./CustomTable";
import ProjectTitle from "./ProjectTitle";
import data_dicription from "../../../../assets/utils/images/project_data_discription.png";
import input_dicription1 from "../../../../assets/utils/images/inputDiscription1.png";
import input_dicription2 from "../../../../assets/utils/images/inputDiscription2.png";
import input_dicription3 from "../../../../assets/utils/images/inputDiscription3.png";
import input_dicription4 from "../../../../assets/utils/images/inputDiscription4.png";
import input_dicription5 from "../../../../assets/utils/images/inputDescription5.png";
import input_dicription6 from "../../../../assets/utils/images/inputDescription6.png";

/**
 * 事業紹介ページ
 * @param {*} param0
 * @returns
 */

// コンポーネント
const ActivityTable = ({ userId, obj }) => {
  const loginStatus = useLoginStatus();
  const myOrgInfo = useMyOrgInfo();
  const { ability } = useUserInfo();
  const myPage = myOrgInfo.id == obj.id;
  // TO DO: Project数分のfalseの配列を挿入すべき
  const [accordion, setAccordion] = useState([
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
    false,
  ]);
  const [editable, setEditable] = useState(false);
  const CloseIcon = Ionicons["IoIosClose"];
  const SettingIcon = Ionicons["IoIosSettings"];
  const LockIcon = Ionicons["IoIosLock"];
  const KeyIcon = Ionicons["IoIosKey"];

  // 定款事業取得
  const orgId = obj.id;
  const { loading, error, data } = useQuery(GET_PROJECTS, {
    variables: {
      orgId: orgId,
    },
  });
  // 定款事業追加
  const [newProjectName, setNewProjectName] = useState("");
  const [createProject] = useMutation(CREATE_PROJECT, {
    update(cache, { data: { addProject } }) {
      const cacheId = cache.identify(addProject.project);
      cache.modify({
        fields: {
          allProject(existingAct, { toReference }) {
            const tmp = [
              ...existingAct.edges,
              { __typename: "ProjectNodeEdge", node: toReference(cacheId) },
            ];
            const new_node = {
              __typename: existingAct.__typename,
              edges: tmp,
            };
            return new_node;
          },
        },
      });
    },
  });
  // 定款事業作成
  const createNewProject = async () => {
    await createProject({
      variables: {
        orgId: orgId,
        userId: userId,
        name: newProjectName,
      },
    });
    await setNewProjectName("");
  };
  // 更新はこちらモーダル関係
  const [disctiptionModal, setDisctiptionModal] = useState(false);
  const toggleDiscriptionModalStatus = () => {
    setDisctiptionModal(!disctiptionModal);
  };
  const [inputDisctiptionModal, setInputDisctiptionModal] = useState(false);
  const toggleInputDiscriptionModalStatus = () => {
    setInputDisctiptionModal(!inputDisctiptionModal);
  };

  function toggleAccordion(index) {
    setAccordion(accordion.map((item, i) => (i == index ? !item : item)));
  }
  function toggleWholeAccordion(boolean) {
    setAccordion(accordion.map((item) => boolean));
  }
  function toggleEditable() {
    setEditable(!editable);
  }

  // ドロップダウン 事業の年度ソート
  const [fiscalYear, setFiscalYear] = useState(obj.newestActYear);
  let all_fiscal_year = [2017, 2018, 2019, 2020, 2021, 2022, 2023, 2024];
  let doropdownData = all_fiscal_year.map((ary) => ({
    id: ary,
    color: `${ary}年度`,
  }));
  let dropdownDataOrder = doropdownData.sort((a, b) => {
    return a.id > b.id ? -1 : 1;
  });

  if (loading)
    return (
      <div className="loading__wrapper">
        <img
          style={{ width: "80px", margin: "auto" }}
          src={animetionLogo}
        ></img>
      </div>
    );

  return (
    <Fragment>
      <CSSTransitionGroup
        component="div"
        transitionName="TabsAnimation"
        transitionAppear={true}
        transitionAppearTimeout={0}
        transitionEnter={false}
        transitionLeave={false}
      >
        <Row>
          <Col md="12">
            <Card className="main-card mb-4">
              <div className="org_contentarea pb-0">
                <div
                  className="org_subtitle_sec"
                  style={{ marginBottom: "0px", justifyContent: "start" }}
                >
                  <h4 className="org_subtitle mr-3">事業紹介と実績</h4>
                  {fiscalYear == "0" ? (
                    <DropdownList
                      data={dropdownDataOrder}
                      value={fiscalYear == "0" ? "-" : fiscalYear + "年度"}
                      dataKey="id"
                      textField="color"
                      defaultValue={""}
                      disabled
                      style={{ width: 200 }}
                    />
                  ) : (
                    <DropdownList
                      data={dropdownDataOrder}
                      value={fiscalYear + "年度"}
                      dataKey="id"
                      textField="color"
                      defaultValue={""}
                      onChange={(e) => setFiscalYear(e.id)}
                      style={{ width: 200 }}
                    />
                  )}
                  {myPage && (
                    <>
                      <div
                        href="#"
                        className="ml-3 pointer"
                        onClick={(e) => {
                          toggleDiscriptionModalStatus();
                        }}
                        style={{ textDecoration: "underline" }}
                      >
                        ※データ反映
                      </div>
                      <div
                        href="#"
                        className="ml-3 pointer"
                        onClick={(e) => {
                          toggleInputDiscriptionModalStatus();
                        }}
                        style={{ textDecoration: "underline" }}
                      >
                        ※事業紹介と実績の入力方法
                      </div>
                    </>
                  )}
                  <Modal
                    isOpen={disctiptionModal}
                    toggle={toggleDiscriptionModalStatus}
                  >
                    <ModalBody>
                      <h6 className="bold text-center my-4">
                        事業数・事業額・従事者数・受益者数へのデータ反映について
                      </h6>
                      <img src={data_dicription} className="ema__w100 mb-4" />
                      <div className="mb-4">
                        <h7 className="bold">1.対象データ</h7>
                        <ul className="mt-3">
                          <li>
                            対象年度：登録されている「事業紹介と実績」の中で最も新しい年度
                          </li>
                          <li>
                            対象データ：対象年度で入力された事業数・事業額・従事者数・受益者数の合計
                          </li>
                        </ul>
                        <h7 className="bold">2.更新のタイミング</h7>
                        <ul className="mt-3">
                          <li>
                            事業紹介と実績を追加しても、タイムリーにはデータが表示・反映されません。
                          </li>
                          <li>
                            リロードすることで、追加情報の反映を確認できます。
                          </li>
                        </ul>
                      </div>
                    </ModalBody>
                  </Modal>
                  <Modal
                    isOpen={inputDisctiptionModal}
                    toggle={toggleInputDiscriptionModalStatus}
                  >
                    <ModalBody>
                      <h6 className="bold text-center my-5">
                        事業紹介と実績の入力方について(事業紹介と実績を入力する前にご一読ください）
                      </h6>
                      <p className="ema__w90 mx-auto">
                        　本箇所は、特定非営利活動法人が管轄省庁に提出する事業報告書の「事業の実施に関する事項」に記載をイメージして設定しております。
                      </p>
                      <img
                        src={input_dicription1}
                        className="ema__w80 my-4 mx-auto d-block"
                      />
                      <p className="mb-4 ema__w90 mx-auto">
                        　公益法人や一般法人・その他法人格・任意団体で、必ずしも同様な書類があるわけではありませんが、アニュアルレポートや活動報告書を参考に記入できる範囲で入力をお願いします。
                      </p>
                      <p className="mb-4  ema__w90 mx-auto">
                        従事者数：本事業に取り組むスタッフ、現地スタッフ、業務委託者などの合計人数
                        <br />
                        事 業 費 ：本事業にかかった事業費（単位：円）
                        <br />
                        受益者数：本事業を通して受益した合計人数
                      </p>
                      <h6 className="bold text-center my-5">
                        【事業紹介と実績の隣の年度セレクト(オレンジ枠)が“-”で表示される場合】
                      </h6>
                      <ol>
                        <li className="mt-3">
                          青枠内の「事業カテゴリー」を入力し、追加を押す。（例：アジアにおける開発事業）
                        </li>

                        <img
                          src={input_dicription3}
                          className="ema__w100 mb-4"
                        />
                        <li className="mt-4 mb-4">
                          上記追加を押すと下記の青枠の通り追加されます。オレンジ枠内の「事業名」を入力し、追加を押す。(例：カンボジアにおける教育事業)
                        </li>
                        <img
                          src={input_dicription2}
                          className="ema__w100 mb-4"
                        />
                        <li className="mt-4 mb-4">
                          2.上記追加を押すと下記の青枠の通り事業名が追加されます。オレンジ枠内の「活動年
                          度」等の右側にある鉛筆マークを押し、編集ができます。
                          (例：活動年度を2021、活動国
                          をカンボジア(複数選択できます)、SDGs 1&4)など)
                        </li>
                        <img
                          src={input_dicription4}
                          className="ema__w100 mb-4"
                        />
                        <li className="mt-4 mb-4">
                          上記入力を押すと下記の各項目が入力され、同時に4項目へ数値が反映されます。「事業カテゴリー」「事業名」を追加し、データをアップデートしてください。
                        </li>
                        <img
                          src={input_dicription5}
                          className="ema__w100 mb-4"
                        />
                      </ol>
                      <h6 className="bold text-center my-5">
                        【事業紹介と実績の隣の年度セレクトが選択でき、年度が表示される場合】
                      </h6>
                      <ol>
                        <li className="mt-4 mb-4">
                          年度を選択し、「事業カテゴリー」「事業名」を追加していきます。具体的な記載は、【事業紹介と実績の隣の年度セレクト（オレンジ枠）が
                          “-” で表示される場合】の2.と 同様となります。
                        </li>
                        <img
                          src={input_dicription6}
                          className="ema__w100 mb-4"
                        />
                      </ol>
                    </ModalBody>
                  </Modal>
                </div>
              </div>

              <CardBody className="mt-4 mb-4">
                {loginStatus ? (
                  <>
                    {data &&
                      data.allProject &&
                      data.allProject.edges.map((node, i) => (
                        <>
                          <Card>
                            <CardHeader id="headingOne">
                              <div
                                className="flex-ai-center"
                                style={{ width: "100%", display: "block" }}
                              >
                                <>
                                  <ProjectTitle
                                    projectTitle={node.node.name}
                                    projectId={node.node.id}
                                    i={i}
                                    accordion={accordion}
                                    toggleAccordion={toggleAccordion}
                                    orgId={orgId}
                                    userId={userId}
                                    myPage={myPage}
                                  />
                                </>
                              </div>
                            </CardHeader>
                            <Collapse
                              isOpen={accordion[i]}
                              data-parent="#accordion"
                              id="collapseOne"
                              aria-labelledby="headingOne"
                            >
                              <CardBody style={{ overflow: "scroll" }}>
                                <CustomTable
                                  key={i}
                                  index={i}
                                  obj={obj}
                                  editable={editable}
                                  userId={userId}
                                  project_id={node.node.id}
                                  myPage={myPage}
                                  year={fiscalYear}
                                />
                              </CardBody>
                            </Collapse>
                          </Card>
                        </>
                      ))}
                    {myPage && ability == "can_edit" ? (
                      <div style={{ textAlign: "center" }} className="mt-3">
                        <span class="lnr lnr-plus-circle pointer">
                          <input
                            className="p-2 mx-2 ema__newbiz"
                            placeholder="事業カテゴリー"
                            value={newProjectName}
                            onChange={(e) => setNewProjectName(e.target.value)}
                          />{" "}
                          {newProjectName ? (
                            <Button onClick={(e) => createNewProject()}>
                              追加
                            </Button>
                          ) : (
                            <Button disabled>追加</Button>
                          )}
                        </span>
                      </div>
                    ) : (
                      <></>
                    )}
                  </>
                ) : (
                  <Col sm="12" style={{ position: "relative", height: 300 }}>
                    <div className="needLogin">
                      <div className="item">
                        <p className="message ema__flex ema__align_items_center">
                          <LockIcon fontSize="30px" />
                          サインアップして分析結果を見る
                        </p>
                        <button
                          className="ema__btn__signup"
                          style={{ margin: "auto" }}
                        >
                          <Link
                            to="/pages/login"
                            style={{
                              marginRight: 10,
                              cursor: "pointer",
                              color: "white",
                            }}
                          >
                            <KeyIcon fontSize="23px" />
                            サインアップ
                          </Link>
                        </button>
                      </div>
                    </div>
                  </Col>
                )}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </CSSTransitionGroup>
    </Fragment>
  );
};

export default ActivityTable;
